<template>
  <section class="default-info blocks-info py-5">
    <div class="container">
      <div
        v-if="blocks.length"
        class="row default-blocks justify-content-center mt-5"
      >
        <div
          v-for="(block, i) in blocks"
          :key="i"
          class="col-12 col-lg-4 mb-5 cursor-pointer"
        >
          <a v-if="block.type === 'enjoj\\feed\\UrlItem'" :href="block.itemable.url" target="_blank">
            <ec-block-item
              :color="surrounding.style"
              :image="block.graphic.data.graphic"
              :title="block.text"
              :surroundingId="surrounding.id"
            />
          </a>
          <router-link v-else class="nav-link" :to="getRoute(block)">
            <ec-block-item
              :color="surrounding.style"
              :image="block.graphic.data.graphic"
              :title="block.text"
              :surroundingId="surrounding.id"
            />
          </router-link>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'
import ecBlockItem from '@/components/Business/components/Blocks/Item'
import _ from 'lodash'

export default {
  name: 'ec-business-blocks',
  components: {
    ecBlockItem
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      blocks: []
    }
  },
  methods: {
    ...mapMutations([
      'setDialog'
    ]),
    getRoute (item) {
      const route = this.$route.path + '/' + _.kebabCase(item.text)
      return route
    }
  },
  created () {
    if (this.item.children !== undefined) {
      this.item.children.data.forEach(block => {
        if (block.itemable !== null) {
          this.blocks.push(block)
        }
      })
    }
  }
}
</script>
